import React, { useState } from 'react';
import { ReptoolModal } from './ReptoolModal.tsx';
import { BasicFetch } from '../../utils/BasicFetch.ts';


export const SuggestSpeciesModal = ({ closeModal }) => {
    const [SpeciesName, setSpeciesName] = useState('');
    const [description, setDescription] = useState('');


    const submitSpecies = () => {
        const data = {
            name: SpeciesName,
            description,
            reptile: localStorage.getItem('selectedReptile'),
            genes: []
        };
        BasicFetch({
            url: `${(window as any).serverLocation}reptile/create_morph`,

            method: 'POST',
            data: data,
            onSuccess: (resp) => {
                window.alert("Species was successfully submitted for approval");
                closeModal();
            },
            onFail: () => {
                console.log("fail")
            }
        });
    }


    return (
        <ReptoolModal title="Suggest A Species" closeModal={() => closeModal(false)} body={
            <React.Fragment>
                <div className="mt-3 d-flex flex-column has-validation">
                    <h6>Species Name:</h6>
                    <div className="ui-textinput ui-corner-all ui-shadow-inset ui-textinput-text ui-body-inherit">
                        <input id="Species" type="text" value={SpeciesName} onChange={(event) => setSpeciesName(event.target.value)} className="w-100 form-control bg-black text-blue rounded" />
                    </div>
                    <div className="invalid-feedback">Species name required</div>
                </div>
                <div className='mt-3'>
                    <h6>Description:</h6>
                    <textarea className='w-100' value={description} onChange={(event) => setDescription(event.target.value)} rows={3} />
                </div>

                <div className='mt-3 d-flex flex-column'>
                    <div onClick={() => submitSpecies()} className="btn mt-3 button w-100">Submit Species For Approval</div>
                </div>
            </React.Fragment>

        } />
    )
}